<template>
	<div>
		<loading v-if="!(loaded && paymentList.length > 0)" />
		<div class="md-layout" v-if="loaded && paymentList.length > 0">
			<div class="md-layout-item md-small-size-100 md-size-100"
				style="display: flex; justify-content:space-between; align-items: center;">

				<div style="display: flex; align-items: center;">
					<h3>ព័ត៌មានអំពីរំលោះ</h3>
					<div>
						<router-link :to="'/loans/edit/' + loan.hash">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រែរំលោះ</md-tooltip>
							</md-button>
						</router-link>
					</div>
				</div>
				<div>
					<a :href="'#/print_loan/' + loan.hash" target="_blank">
						<md-button class="md-just-icon md-simple md-primary">
							<md-icon>print</md-icon>
							<md-tooltip>បោះពុម្ភតារាងបង់ប្រាក់</md-tooltip>
						</md-button>
					</a>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">

				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">លេខកូដ</md-table-cell>
						<md-table-cell style="width: 5px">:</md-table-cell>
						<md-table-cell><b>
							<span v-if="String(loan.hash).length > 0">{{loan.hash}}</span>
							<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ទីតាំងគម្រោង</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(loan.project_name).length > 0">{{loan.project_name}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>លេខឡូតិ៍</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(loan.lot).length > 0">{{loan.lot}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>តម្លៃសរុប</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(loan.amount).length > 0">{{config.moneylify(loan.amount)}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ការប្រាក់</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(loan.interest_rate).length > 0">{{loan.interest_rate}}%</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ចំនួនខែបង់</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(loan.total_term).length > 0">{{loan.total_paid_term - 1}} / {{loan.total_term - 1}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ថ្ងៃបង់ប្រាក់បន្ទាប់</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span class="active" v-if="loan.status == 'act'">{{config.datelifyShort(loan.next_payment)}}</span>
							<span class="active" v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>

				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>Client Detail</h3> -->
				<md-table>
					<md-table-row>
						<md-table-cell>លេខកូដអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(loan.client_hash).length > 0">{{loan.client_hash}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ឈ្មោះអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(loan.client_name).length > 0">{{loan.client_name}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell style="width: 40%;">លេខទូរស័ព្ទ</md-table-cell>
						<md-table-cell style="width: 5px;">:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(loan.client_phone).length > 0">{{loan.client_phone}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>

					<md-table-row>
						<md-table-cell>ស្ថានភាពរំលោះ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span class="active" v-if="loan.status == 'act'">{{config.getStatus(loan.status)}}</span>
							<span class="late" v-if="loan.status == 'fin'">{{config.getStatus(loan.status)}}</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>កំណត់ចំណាំ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(loan.note).length > 0">{{loan.note}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ថ្ងៃបង្កើតរំលោះ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(loan.created_date).length > 0">{{config.datelify(loan.created_date)}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>បង្កើតដោយ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(loan.created_by).length > 0">{{loan.created_by}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>តារាងបង់ប្រាក់</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="paymentList.length > 0">
					<md-table-row>
						<md-table-head>ខែ</md-table-head>
						<md-table-head>លេខកូដ</md-table-head>
						<md-table-head>ថ្ងៃបង់ប្រាក់</md-table-head>
						<md-table-head>ប្រាក់ដើម</md-table-head>
						<md-table-head>ការប្រាក់</md-table-head>
						<md-table-head>ប្រាក់ត្រូវបង់</md-table-head>
						<md-table-head>ប្រាក់ដើមនៅសល់</md-table-head>
						<md-table-head>ប្រាក់ពិន័យ</md-table-head>
						<md-table-head>ស្ថានភាព</md-table-head>
						<md-table-head>សកម្មភាព</md-table-head>
					</md-table-row>

					<md-table-row v-for="(payment, index) in paymentList">
						<md-table-cell>{{ payment.term_id }}</md-table-cell>
						<md-table-cell>{{ payment.hash }}</md-table-cell>
						<md-table-cell>{{ config.datelifyShort(payment.due_date) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
						<md-table-cell><b>{{ config.moneylify(payment.interest + payment.principal)}}</b></md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.balance) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.fine) }}</md-table-cell>
						<md-table-cell>
							<span class="late" v-if="payment.status == 'pnd'">{{ config.getStatus(payment.status) }}</span>
							<span class="active" v-if="payment.status == 'pad'">{{ config.getStatus(payment.status) }}</span>
						</md-table-cell>
						<md-table-cell>
							<!-- <div v-if="payment.next == 1" class="payment-action"> -->
							<div v-if="payment.status == 'pnd' && payment.next == 1" class="payment-action">
								<div v-if="payment.due_date > ((new Date()).getTime() / 1000)" @click="payPayment(payment.id)">
									<md-icon style="color:green; cursor: pointer;">price_check</md-icon>
									<md-tooltip md-direction="top">បង់ប្រាក់</md-tooltip>
								</div>
								<div v-if="payment.due_date < ((new Date()).getTime() / 1000)" @click="openLateDialog(payment.id)">
									<md-icon style="color:red; cursor: pointer;">price_check</md-icon>
									<md-tooltip md-direction="top">បង់ប្រាក់</md-tooltip>
								</div>
								<router-link :to="'/loans/add_principal/' + $route.params.hash">
									<div>
										<md-icon style="color: #8e44ad; cursor: pointer; margin: 0 15px">price_change</md-icon>
										<md-tooltip md-direction="top">កែប្រែបង់ប្រាក់ដើមបន្ថែម</md-tooltip>
									</div>
								</router-link>
								<div @click="payAll(payment.id)">
									<md-icon style="color: #16a085; cursor: pointer;">money</md-icon>
									<md-tooltip md-direction="top">បង់ផ្តាច់</md-tooltip>
								</div>
							</div>

							<div v-if="payment.status == 'pad'" class="paid-payment">
								<a :href="'#/print_receipt/' + payment.hash" target="_blank">
									<md-icon style="color: #f39c12; cursor: pointer;">print</md-icon>
									<md-tooltip md-direction="top">បោះពុម្ភបង្កាន់ដៃបង់ប្រាក់</md-tooltip>
								</a>
								<p class="paid-text"> {{config.datelify(payment.paid_date)}} ({{payment.paid_by}})</p class="paid-text">
							</div>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<!-- <div class="md-layout-item md-size-100 text-right"
				v-if="loan.status != 'fin' && loan.total_paid < loan.term - 1">
				<md-button class="md-raised md-primary" @click="payAllDialog = true">
					Pay All</md-button>
			</div> -->
		</div>
		<Transition>
			<div class="box" v-show="payAllDialog">
				<div class="box-content">
					<div class="title">ការបង់ផ្តាច់រំលោះ</div>
					<div class="box-content-body">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<table style="width: 100%">
									<tr>
										<td style="width: 40%;">ប្រាក់ដើមត្រូវបង់</td>
										<td style="width: 50px">:</td>
										<td>{{config.moneylify(payAllData.principal)}}</td>
									</tr>
									<tr>
										<td style="width: 40%;">ការប្រាក់ត្រូវបង់</td>
										<td style="width: 50px">:</td>
										<td>{{config.moneylify(payAllData.interest)}}</td>
									</tr>
									<tr>
										<td style="width: 40%;">ទឹកប្រាក់ត្រូវបង់សរុប</td>
										<td style="width: 50px">:</td>
										<td>{{config.moneylify(payAllData.total)}}</td>
									</tr>
								</table>
							</div>
							<div class="md-layout-item md-size-100 text-right">
								<md-button class="md-raised md-danger" @click="onCancel()">បោះបង់</md-button>
								<md-button class="md-raised md-success" @click="payAll()">យល់ព្រម</md-button>
							</div>
						</div>

					</div>

				</div>
			</div>
		</Transition>
		<Transition>
			<div class="box" v-show="payMorePrincipalDialog">
				<div class="box-content">
					<div class="title">ការបង់បន្ថែមប្រាក់ដើម</div>
					<div class="box-content-body">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-60 md-size-60">
								<md-field>
									<label>ទឹកប្រាក់ដែលត្រូវបង់</label>
									<md-input type="text" v-model="payMorePrincipalData.new_amount"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-40 md-size-40">
								<md-field>
									<label>ចំនួនខែត្រូវបង់ថ្មី</label>
									<md-input type="text" v-model="payMorePrincipalData.new_term"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<table style="width: 100%">
									<tr>
										<td style="width: 40%;">ប្រាក់ដើមត្រូវបង់</td>
										<td style="width: 50px">:</td>
										<td> $ 10,5912.00</td>
									</tr>
									<tr>
										<td style="width: 40%;">ការប្រាក់ត្រូវបង់</td>
										<td style="width: 50px">:</td>
										<td> $ 10,5912.00</td>
									</tr>
									<tr>
										<td style="width: 40%;">ទឹកប្រាក់ត្រូវបង់សរុប</td>
										<td style="width: 50px">:</td>
										<td> $ 10,5912.00</td>
									</tr>
								</table>
							</div>
							<div class="md-layout-item md-size-100 text-right">
								<md-button class="md-raised md-danger" @click="onCancel()">បោះបង់</md-button>
								<md-button class="md-raised md-success" @click="payAll()">យល់ព្រម</md-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Transition>
		<md-dialog-confirm :md-active.sync="payDialog" md-title="តើអ្នកពិតជាចង់ទូទាត់ប្រាក់មែនឬ ?" md-content=""
			md-confirm-text="យល់ព្រម" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="payPayment" />
		<!-- <md-dialog-confirm :md-active.sync="payAllDialog"
			:md-title="'Are you sure want to finish this loan ? Total payment is ' + config.moneylify(payAllTotal)"
			md-content="" md-confirm-text="យល់ព្រម" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="payAllPayment" /> -->

		<md-dialog-prompt :md-active="lateDialog" md-title="ប្រាក់ពិន័យ" md-confirm-text="យល់ព្រម"
			md-cancel-text="បោះបង់" md-input-maxlength="8" md-input-placeholder="ចំនួនប្រាក់ពិន័យ" @md-cancel="onCancel"
			@md-confirm="payLatePayment()" v-model="lateFee" ref="dialog">
		</md-dialog-prompt>
	</div>
</template>
<script>
	export default {
		created() {
			this.getLoan();
			this.getPayment();
			// this.getPayAllTotal();
		},
		data() {
			return {
				loaded: false,
				paymentList: [],
				guarantorList: [],
				payDialog: false,
				lateDialog: false,
				payAllDialog: false,
				payAllData: {
					principal: 0,
					interest: 0,
					total: 0
				},
				payMorePrincipalDialog: false,
				payMorePrincipalData: {
					new_amount: "",
					new_term: ""
				},
				payID: "",
				payLateID: "",
				lateFee: "0",
				payAllTotal: 0,
				loan: {
					id: "",
					hash: "",
					interest_amount: "",
					loan_fee: "",
					total_payment: "",
					amount: "",
					term: "",
					initial_payment: "",
					monthly_payment: "",
					start_date: "",
					end_date: "",
					name: "",
					phone: "",
					next_payment: "",
					loan_balance: "",
					total_paid: "",
					note: "",
					status: ""
				},
			}
		},
		methods: {
			getLoan(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get/" + this.$route.params.hash).then(data => {
					this.loan = data.body.data
					this.loaded = true
				})
			},
			getPayment() {
				this.$http.get(this.config.api + "/admin/loan/get_payment/" + this.$route.params.hash).then(data => {
					let paymentList = data.body.data
					// let trigger = 0;
					for(let i =0; i < paymentList.length; i++) {
						if(paymentList[i].status == 'pnd') {
							paymentList[i].next = 1;
							break;
						}
					}
					this.paymentList = paymentList
				})
			},
			// getPayAllTotal() {

			// },
			payPayment(id = "") {
				if (id == "" && String(this.payID).length > 0) {
					this.$http.post(this.config.api + "/admin/loan/pay/payment", {
						payment_id: this.payID,
						late_fee: "0",
						loan_id: this.loan.id
					}).then(data => {
						if (data.body.status == 'success') {
							this.getPayment();
							this.getLoan();
							window.open("#/print_receipt/" + data.body.data.payment_hash, '_blank');
						}
					})
				} else {
					this.payID = id;
					this.payDialog = true;
				}

			},
			openLateDialog(id) {
				this.lateDialog = true;
				this.payLateID = id;
			},
			payLatePayment() {

				let id = this.payLateID;
				let fee = this.lateFee;
				this.onCancel();
				if (String(id).length > 0 && String(fee).length > 0) {
					this.$http.post(this.config.api + "/admin/loan/pay/payment", {
						payment_id: id,
						late_fee: fee,
						loan_id: this.loan.id
					}).then(data => {
						if (data.body.status == 'success') {
							this.getPayment();
							this.getLoan();
							window.open("#/print_receipt/" + data.body.data.payment_hash, '_blank');
						}
					})
				}

			},
			payMorePrincipal() {
				this.payMorePrincipalDialog = true;
				// this.$http.post(this.config.api + "/admin/loan/pay_all/payment", {
				// 	loan_id: this.loan.id
				// }).then(data => {
				// 	if (data.body.status == 'success') {
				// 		this.getPayment();
				// 		this.getLoan();
				// 	}
				// })
			},
			payAll() {
				if(this.payAllDialog == false) {
					this.$http.get(this.config.api + "/admin/loan/get/pay_all/" + this.$route.params.hash).then(data => {
						this.payAllData.principal = data.body.data.principal
						this.payAllData.interest = data.body.data.interest
						this.payAllData.total = data.body.data.total
						this.payAllDialog = true;
					})
				}

				if(this.payAllDialog == true) {
					this.$http.post(this.config.api + "/admin/loan/pay_all", {
						hash: this.loan.hash
					}).then(data => {
						if (data.body.status == 'success') {
							this.onCancel();
							this.getPayment();
							this.getLoan();
						}
					})
				}


			},
			onCancel() {
				this.payDialog = false;
				this.lateDialog = false;
				this.payAllDialog = false;
				this.payMorePrincipalDialog = false;
				this.payID = "";
				this.lateFee = "0";
			}
		}
	}
</script>

<style>
	.paid-text {
		margin: 0 0 0 12px;
	}
	.paid-payment {
		display: flex;
		align-items: center;

	}
	.box {
		width: 100%;
		height: 100%;
		z-index: 999;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		left: 0;
		position: fixed;
		background-color: rgba(0,0,0,0.6);
		transition: visibility 0s, opacity 0.5s linear;
	}
	.box-content {
		background-color: #FFF;
		width: 90%;
		max-width: 500px;
		padding: 15px;
		border-radius: 15px;
	}
	.title {
		width: 100%;
		font-size: 18px;
		font-weight: bold;
	}
	.box-content-body {
		width: 100%;
		padding: 10px 0 0 0;
		font-weight: bold;
	}
	.v-enter-active,
	.v-leave-active {
		transition: opacity 0.6s ease;
	}

	.v-enter-from,
	.v-leave-to {
		opacity: 0;
	}
	.payment-action {
		display: flex;
		flex-direction: row;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Loans/Detail.vue